let animationsZone1 = {
    tennisBall: () => {

        // vars
        let tennisBall = ".tennisBall",
            circleArc = ".circleArc",
            circleArcHide = ".circleArcHide",
            barEyes = ".barEyes",
            tl = new TimelineMax({
                repeat: -1
            });

        tl.to(tennisBall, 2, {
                rotation: -720,
                transformOrigin: "center"
            }).to(circleArc, 2, {
                rotation: 60,
                transformOrigin: "center"
            }, "-=2")
            .to(circleArcHide, 2, {
                rotation: 60
            }, "-=2")
            .to(barEyes, 2, {
                rotation: -19,
                x: -5,
                y: -5,
                scale: 0.85
            }, "-=2")
            .to(tennisBall, 2, {
                rotation: 0,
                transformOrigin: "center"
                    // transformOrigin: "40% 50% 0"
            })
            .to(circleArc, 2, {
                rotation: 0,
                transformOrigin: "center"
            }, "-=2")
            .to(barEyes, 2, {
                rotation: 0,
                x: 0,
                y: 0,
                scale: 1
            }, "-=2")
            .to(circleArcHide, 2, {
                rotation: 0
            }, "-=2");
    }
};

$(document).ready([animationsZone1.tennisBall]);
